export default __webpack_public_path__ + "static/media/salon-app-circle.d96893b6.webp";